<template>
  <div class="container">
    <h1> {{ title }} </h1>
    <div class="apps">
      <h2>Apps</h2>
      <div class="box-content">
        <app-box v-for="(item, index) in apps" :title="item.title" :WorkImg="item.WorkImg" :index="index"></app-box>
      </div>
    </div>
    <div class="intern">
      <h2>Intern</h2>
      <div class="box-content">
        <intern-box v-for="(item, index) in intern" :title="item.title" :WorkImg="item.WorkImg" :index="index"></intern-box>
      </div>
    </div>
  </div>
</template>
<script>
  import PageTitle from "../components/modules/PageTitle";
  import AppBox from "../components/modules/AppBox";
  import Modal from "../components/modules/Modal";
  import InternBox from "../components/modules/InternBox"
  import { mapGetters } from "vuex"

  export default {
    name: 'Works',
    components: {
      AppBox,
      InternBox,
      PageTitle,
      Modal
    },
    computed: {
      ...mapGetters('Works',{
        'apps': 'getAllApp',
        'intern': 'getAllIntern',
        'title': 'getTitle'
      })
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/Works.vue